<template>
  <b-row>
    <b-col>
      <div class="p-2">
        <div class="filter-input-wrapper postcode d-flex align-items-center pb-2 mr-0">
          <location-marker-icon class="md-heroicon text-dark" />
          <b-input-group class="icon-padding">
            <b-form-input
              ref="postcode"
              v-model="params.postcode"
              class="border-color"
              placeholder="Postcode/Location"
              aria-label="postcode"
            />

            <b-input-group-append v-if="params.postcode">
              <b-button
                variant="primary"
                @click="resetParamValue('postcode')"
              >
                <XIcon class="md-heroicon white mr-0" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>

        <div class="filter-input-wrapper service-type d-flex align-items-center pb-2">
          <office-building-icon
            class="md-heroicon text-dark"
            aria-label="office building icon"
          />

          <label
            class="sr-only"
            for="service"
          >
            Please select service type
          </label>

          <app-single-multi-select
            id="service"
            v-model="params.service_type_id"
            role="option"
            aria-multiselectable="false"
            :options="serviceTypes"
            placeholder="Service type"
            class="service-type-select icon-padding border-color"
            open-direction="bottom"
            aria-label="please select service types"
          />

          <b-button
            v-if="params.service_type_id"
            variant="primary"
            class="reset-service-type-btn"
            @click="resetParamValue('service_type_id')"
          >
            <XIcon class="md-heroicon white mr-0" />
          </b-button>
        </div>
        <div class="filter-input-wrapper date d-flex align-items-center">
          <calendar-icon
            class="md-heroicon text-dark"
            aria-label="calendar-icon"
          />

          <label
            class="sr-only"
            for="date-picker"
          >
            Date Picker
          </label>

          <v-date-picker
            id="date-picker"
            ref="date-picker"
            v-model="params.date"
            aria-label="date picker"
            popover-visibility="click"
            class="datepicker-popover col-12 r"
            :input-props="{
              class: 'form-control datepicker border-color',
              placeholder: 'Select date',
              label:'date picker',
            }"
          />
        </div>
        <div />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  CalendarIcon,
  LocationMarkerIcon,
  OfficeBuildingIcon,
  XIcon
} from '@vue-hero-icons/outline'


export default {

  components: {
    CalendarIcon,
  	LocationMarkerIcon,
  	OfficeBuildingIcon,
    XIcon,

  },
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

    ...mapGetters('core', [
      'serviceTypes'
    ]),

  },

  methods: {
    resetParamValue(name) {
  		this.params[name] = ''
  	},
    fetchResults() {
  		this.$emit('search', this.params)
  	},
  }
}
</script>

<style>

.icon-padding{
  padding-left: 15px
}
.border-color{
  border-color: #5A5A5A;
}

.multiselect__tags{
   border-color: #5A5A5A;
}

</style>